import {
	apiRequest,
	processInput,
	addNewFilter,
	processQueryParams,
	isEmpty
} from "@/utilities"

const state = {
	loading: false,
	userSettings: [],
}

import { userSettingService } from "@/services"

const getters = {
	userSettings: state => state.userSettings,
	userSettingByUserUuid: state => userUuid => state.userSettings.find(us => us.user_uuid == userUuid)
}

const actions = {
	async createUserSetting({ commit, dispatch }, userSettingData) {
		commit("CREATE_USER_SETTING_REQUEST")
		const response = await userSettingService.createUserSetting(userSettingData)
		const { status, data } = response;

		switch (status) {
			case 200:
				if(data.success) {
					dispatch("alert/createAlertSuccess", "Setting updated.", { root: true });
					commit("CREATE_USER_SETTING_SUCCESS", data);
				}

				if(data.error) {
					dispatch('alert/createAlertErrors', data.errors, { root: true })
				}
				
				break
			case 403:
				commit("CREATE_USER_SETTING_ERROR", data)
				const { message } = data
				let messages = message ?? "NOT Authorized for this action."
				dispatch('alert/createAlertErrors', messages, { root: true })
				break
			default:
				commit("CREATE_USER_SETTING_ERROR", data)
		}

		return response;
	},
	async editUserSetting({ commit, dispatch }, params) {
		commit("EDIT_USER_SETTING_REQUEST")
		let editData = processInput(params)
		editData.append("_method", "PATCH");
		const updateRequest = {
			method: "POST",
			data: editData
		}
		let uuid = params.uuid
		const response = await apiRequest(`/api/user-settings/${uuid}`, updateRequest);
		const { status, data } = response
		switch (status) {
			case 200:
				commit("EDIT_USER_SETTING_SUCCESS", data);
				if (data.success) {
					dispatch("alert/createAlertSuccess", "Setting updated.", { root: true })
				}

				if (data.error) {
					dispatch('alert/createAlertErrors', data.errors, { root: true })
				}
				break
			default:
				commit("EDIT_USER_SETTING_ERROR", data)
		}
		return response
	},
}

const mutations = {
	EDIT_USER_SETTING_REQUEST: state => {
		state.loading = true
	},
	GET_USER_SETTINGS_SUCCESS: (state, data) => {
		const user_setting = data.user_setting
		state.userSettings = addNewFilter(state.userSettings, [user_setting])
		state.loading = false
	},
	CREATE_USER_SETTING_REQUEST: state => {
		state.loading = true;
	},
	CREATE_USER_SETTING_ERROR: (state, data) => {
		state.loading = false;
	},	
	CREATE_USER_SETTING_SUCCESS: (state, data) => {
		const user_setting = data.user_setting
		state.userSettings = addNewFilter(state.userSettings, [user_setting])
		state.loading = false;
	},
	EDIT_USER_SETTING_SUCCESS: (state, data) => {
		const user_setting = data.user_setting
		state.userSettings = addNewFilter(state.userSettings, [user_setting])
		state.loading = false
	},
	EDIT_USER_SETTING_ERROR: (state, data) => {
		state.loading = false
	},
}

export const userSetting = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
